import { SagaMiddleware } from 'redux-saga'
import { sagas as creditCheckSagas } from './creditCheck'

interface SagaMetadata {
  /* tslint:disable no-any */
  [_: string]: any
  /* tslint:enable no-any */
}

const sagas: SagaMetadata = {
  creditCheck: creditCheckSagas,
}

const registerWithMiddleware = (middleware: SagaMiddleware<{}>): void => {
  for (const name of Object.keys(sagas)) {
    middleware.run(sagas[name])
  }
}

export default registerWithMiddleware



// WEBPACK FOOTER //
// ./src/store/sagaRegistration.ts